module.exports = __webpack_public_path__ + "static/media/desktop_report-ioc.bceb5171.png";